import script from "./TagTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TagTable.vue?vue&type=script&setup=true&lang=js"

import "./TagTable.vue?vue&type=style&index=0&id=0244cf29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0244cf29"]])

export default __exports__